import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getLegalPage } from '../helpers/legal-pages';
import usePageTitle from '../hooks/usePageTitle';
import { Loader2 } from 'lucide-react';
import '../css/LegalPage.css';
import { formatDateFR } from '../hooks/tools';

const LegalPage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPage = async () => {
            setIsLoading(true);
            try {
                const data = await getLegalPage(slug);
                if (!data) {
                    setError('Page not found');
                    navigate('/404');
                    return;
                }
                setPageData(data);
                setError(null);
            } catch (err) {
                setError('Failed to load page');
                console.error('Error loading page:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPage();
    }, [slug, navigate]);

    usePageTitle(pageData?.title || 'Chargement...');

    if (isLoading) {
        return (
            <div className="loading-container d-flex align-items-center justify-content-center min-vh-50">
                <Loader2 className="spinner" />
            </div>
        );
    }

    if (error || !pageData) {
        return null; // The navigate in useEffect will handle this
    }

    return (
        <div className="legal-page">
            <div className="hero-section">
                <div className="container">
                    <h1>{pageData.title}</h1>
                    <p className="subtitle">Dernière modification : {formatDateFR(pageData.updatedAt)}</p>
                    {pageData.meta_description && (
                        <p className="subtitle">{pageData.meta_description}</p>
                    )}
                </div>
            </div>
            
            <div className="container">
                <div className="content-card">
                    <div className="legal-content" 
                         dangerouslySetInnerHTML={{ __html: pageData.content }}>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LegalPage;